import { render } from "./ReleaseResult.vue?vue&type=template&id=2cb650a1&scoped=true"
import script from "./ReleaseResult.vue?vue&type=script&lang=js"
export * from "./ReleaseResult.vue?vue&type=script&lang=js"

import "./ReleaseResult.vue?vue&type=style&index=0&id=2cb650a1&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cb650a1"]])

export default __exports__